export const DEFAULT_WIDTH = "100%";
export const NINETY_PERCENT = 0.9;
export const RESIZE_DEBOUNCE_TIME = 100;
export const SEARCH_DEBOUNCE_TIME = 300;
export const SCROLL_THROTTLE_TIME = 50;
export const ARIA_DESCRIBEDBY_TIMEOUT = 200;
export const SCROLL_ATTACH_TIME = 0;
export const REQUIRED_TEXT = "required";
export const INVALID_SELECTION_TEXT = "invalid selection";
export const MOBILE_BREAKPOINT = 600;
export const BALLOON_POSITION = {
  TOP: "top left",
  BOTTOM: "bottom left"
};